// extracted by mini-css-extract-plugin
export default {"title":"flORaY","mobile":"iRvir0","sortDropdown":"qqi47i","mobileSearch":"CHea__"};